module.exports = __webpack_public_path__ + "media/images/bg/shapes/career/seledyn-ac2079d43de4f36821b15e7c47783a20.svg";